import React from "react"
import "../Styles/smallpost.scss"
import Img from "gatsby-image"
import { Card, Row, Col } from "react-bootstrap"
import { Link } from "gatsby"
import "bootstrap/dist/css/bootstrap.min.css"

const Smallpost = ({ title, slug, date, body, show, fluid }) => {
  return (
    <Link to={slug}  className="smallpost-link">
      <Card className="smallpost" >
        <Row className="smallpost-row">
          <Col sm={5} xs={4}>

                  <div className="card-img">
                      <Img fluid={fluid} alt={title} className="smallpost-image"  />
                  </div>

            
          </Col>
          <Col className="smallpost-alltxts">
            <Card.Body>
              <Card.Title className="smallpost-title">{title}</Card.Title>

              <Card.Text className="smallpost-txt">{body}</Card.Text>
            </Card.Body>
          </Col>
        </Row>
      </Card>
    </Link>
  )
}

export default Smallpost
